import ChannelSettings from './ChannelSettings/index';
export default ChannelSettings;